import FaultCause from './FaultCause.vue'
export default FaultCause


// WEBPACK FOOTER //
// ./src/pages/FaultCause/index.js